export interface IMagazinesState {}

let magazinesState: IMagazinesState = {};

export default magazinesState;